// ========== 漏洞 CVE-2024-6783 + CVE-2024-9506 防御补丁 ==========
// 阻止原型污染 XSS（不使用 Object.freeze，避免 mqtt/bl 等库在子原型上赋值 toString 时报错）
const _defineProperty = Object.defineProperty;
const lockPrototype = (proto) => {
  Object.preventExtensions(proto);
  Object.getOwnPropertyNames(proto).forEach((key) => {
    const desc = Object.getOwnPropertyDescriptor(proto, key);
    if (desc && desc.configurable) {
      _defineProperty(proto, key, { ...desc, configurable: false });
    }
  });
};
lockPrototype(Object.prototype);
lockPrototype(Array.prototype);

// 阻止通过 defineProperty 污染内置原型
Object.defineProperty = function (target, prop, descriptor) {
  if (target === Object.prototype || target === Array.prototype) {
    return target;
  }
  return _defineProperty(target, prop, descriptor);
};
// =
import Vue from 'vue'
import ElementUI from 'element-ui'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css'
import dataV from '@jiaminghi/data-view'
import router from './router.js'
import website from '@/config/website'
import store from './store'
import App from './App.vue'
import './styles/common.scss'
import '@/utils/es6'
import '@/mock/'
//导入主题文件
import '@/theme/index.js'
import './permission' // 权限
Vue.config.productionTip = false
window.axios = axios
Vue.use(Avue, {
  size: 'mini'
})
Vue.prototype.$website = window.$website
// 加载website
Vue.prototype.website = website
Vue.use(ElementUI)
Vue.use(dataV)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
